import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import React__default, { useRef, useState } from 'react';
import { Tooltip } from '../tooltip/tooltip.js';
import styles from './chips-group.module.js';

var ChipsGroup = function ChipsGroup(props) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var count = React__default.Children.count(children); // Used to store each InputChip reference

  var chipsRef = useRef([]); // Used to keep track of the current focused InputChip child

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      focusIndex = _useState2[0],
      setFocusIndex = _useState2[1];

  var setFocus = function setFocus(index) {
    var _chipsRef$current, _chipsRef$current$ind;

    (_chipsRef$current = chipsRef.current) === null || _chipsRef$current === void 0 ? void 0 : (_chipsRef$current$ind = _chipsRef$current[index]) === null || _chipsRef$current$ind === void 0 ? void 0 : _chipsRef$current$ind.focus();
  };

  var handleKeyDown = function handleKeyDown(event) {
    var focusNextChip = function focusNextChip() {
      return setFocus(focusIndex + 1);
    };

    var focusPrevChip = function focusPrevChip() {
      return setFocus(focusIndex - 1);
    };

    var focusFirstChip = function focusFirstChip() {
      return setFocus(0);
    };

    var focusLastChip = function focusLastChip() {
      return setFocus(count - 1);
    }; // Define the action for each supported keyboard code


    var codeToActionMap = {
      ArrowRight: focusNextChip,
      ArrowDown: focusNextChip,
      ArrowLeft: focusPrevChip,
      ArrowUp: focusPrevChip,
      Home: focusFirstChip,
      End: focusLastChip
    };

    if (event.code in codeToActionMap) {
      // Call corresponding action
      codeToActionMap[event.code]();
    }
  };

  var handleDelete = function handleDelete(index) {
    // Remove chip reference
    chipsRef.current.splice(index, 1); // Compute index of the next chip to focus

    var hasDeletedLastChip = index === count - 1;
    var newFocusIndex = hasDeletedLastChip ? index - 1 : index; // Focus next chip

    setFocus(newFocusIndex);
    setFocusIndex(newFocusIndex);
  };

  return jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.chipsGroup, className),
    role: "grid",
    children: React__default.Children.map(children, function (child, index) {
      var _childElement$props$t;

      if (! /*#__PURE__*/React__default.isValidElement(child)) {
        throw Error("Element ".concat(child, " is not a valid React element"));
      }

      if (!child.props.onDelete) {
        throw Error("Input chip must have an onDelete prop.");
      }

      var childElement = child;
      return jsx("div", {
        role: "row",
        children: jsx("div", {
          role: "gridcell",
          children: jsx(Tooltip // Disable interactivity check for this specific tooltip. While the Tooltip always requires the trigger element to be interactive,
          // it is not the case for the Chips Group as per the a11y pattern. In this case, the error is false positive.
          , {
            // Disable interactivity check for this specific tooltip. While the Tooltip always requires the trigger element to be interactive,
            // it is not the case for the Chips Group as per the a11y pattern. In this case, the error is false positive.
            __checkInteractivity: false,
            "aria-hidden": true,
            content: (_childElement$props$t = childElement.props.tooltip) !== null && _childElement$props$t !== void 0 ? _childElement$props$t : childElement.props.label,
            children: /*#__PURE__*/React__default.cloneElement(childElement, {
              // Register the InputChip reference
              ref: function ref(node) {
                if (node) {
                  chipsRef.current[index] = node;
                }
              },
              // Unset value added by Tooltip so that screen readers don't read the label twice
              'aria-describedby': undefined,
              // Make sure to remove InputChip reference when removed + focus the next one
              onDelete: function onDelete() {
                var _childElement$props$o, _childElement$props;

                // We know childElement will always have an onDelete function because of the error
                // above. Optional chaining is to make typescript happy
                (_childElement$props$o = (_childElement$props = childElement.props).onDelete) === null || _childElement$props$o === void 0 ? void 0 : _childElement$props$o.call(_childElement$props);
                handleDelete(index);
              },
              // Handle keyboard navigation
              onKeyDown: handleKeyDown,
              // Update internal state to keep track of the current focused InputChip
              onFocus: function onFocus() {
                return setFocusIndex(index);
              },
              // Only one of the InputChip contained by the grid is included in the page tab sequence
              tabIndex: focusIndex === index ? 0 : -1
            })
          })
        })
      });
    })
  }));
};

export { ChipsGroup };